import { signalStore, withState, withMethods, withComputed, patchState } from '@ngrx/signals';
import { computed, inject } from '@angular/core';
import { PolicyFormGridService } from './policy-form-grid.service';
import { FormViewModel, ProgramEnum } from '@program-suite/data-common';


export const PolicyFormGridStore = signalStore(
  { providedIn: 'root' },
  withState<{ policyForms: FormViewModel[]; filterValues: object }>({
    policyForms: [],
    filterValues: {},
  }),
  withComputed(({ policyForms, filterValues }) => ({
    filteredForms: computed(() => {
      // Add filtering logic here if needed
      return policyForms();
    }),
    debug: computed(() => ({
      filterCount: Object.keys(filterValues()).length,
      formCount: policyForms().length,
    })),
  })),
  withMethods((store, service = inject(PolicyFormGridService)) => ({
    async getPolicyFormGrid(programCode?: ProgramEnum, stateCode?: string): Promise<void> {
      const data = await service.getPolicyFormGrid(programCode, stateCode);
      patchState(store, { policyForms: data  });
    },
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
    clearFilters(): void {
      patchState(store, { filterValues: {} });
    },
  }))
);